/**
 * EmailTemplatesAdmin.tsx — Admin > Forms & Templates > Email Templates: the
 * corporate dashboard's page for the signed-in account (the `email_content`
 * templates, not marketing's), as a drag-and-drop board (see
 * components/admin/MessageTemplateBoard).
 */
import { MessageTemplateBoard } from '@/components/admin/MessageTemplateBoard';

export function EmailTemplatesAdmin() {
  return <MessageTemplateBoard kind="email" />;
}
